module.exports = __webpack_public_path__ + "img/checkmark-p-500.f5ba9aeb.png";